/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createFieldHook } from '../../core/factories/createFieldHook.js';
import { createMarketChartHook } from '../../core/factories/createMarketChartHook.js';

import type { GetMarketChartRow } from '../openapi-types.gen.js';
import { type useGetMarketChartArgs, useGetMarketChartSpec, useGetMarketChartRealtime } from '../specs/markets.spec.gen.js';

export type { GetMarketChartRow } from '../openapi-types.gen.js';
export type { useGetMarketChartArgs } from '../specs/markets.spec.gen.js';

/** Complete finite response; this chart hook has no cursor or infinite variant.
 *
 * @remarks Available query params (forwarded automatically; pass
 * via the hook's args): pubkey, outcomeIndex, interval, property, chartType, from, to, targetBars, mints, liveWindowSeconds. */
export const useGetMarketChart = createMarketChartHook({
  spec: useGetMarketChartSpec,
  realtime: useGetMarketChartRealtime,
  entityKey: 'market',
  snapshotMode: 'post-wire-once',
});


export const useGetMarketChartField = createFieldHook<GetMarketChartRow>('useGetMarketChartField');

